{
  "name": "@adobe/react-spectrum",
  "version": "3.47.0",
  "description": "Spectrum UI components in React",
  "license": "Apache-2.0",
  "main": "./dist/exports/index.cjs",
  "module": "./dist/exports/index.js",
  "exports": {
    ".": {
      "source": "./exports/index.ts",
      "types": "./dist/types/exports/index.d.ts",
      "import": "./dist/exports/index.mjs",
      "require": "./dist/exports/index.cjs"
    },
    "./i18n": {
      "types": "./i18n/index.d.ts",
      "import": "./i18n/index.mjs",
      "require": "./i18n/index.js"
    },
    "./i18n/*": {
      "types": "./i18n/lang.d.ts",
      "import": "./i18n/*.mjs",
      "require": "./i18n/*.js"
    },
    "./package.json": "./package.json",
    "./*": {
      "source": "./exports/*.ts",
      "types": "./dist/types/exports/*.d.ts",
      "import": "./dist/exports/*.mjs",
      "require": "./dist/exports/*.cjs"
    }
  },
  "types": "./dist/types/exports/index.d.ts",
  "source": "exports/index.ts",
  "files": [
    "*",
    "!chromatic/**",
    "!chromatic-fc/**",
    "!docs/**",
    "!exports/**",
    "!intl/**",
    "!scripts/**",
    "!src/**",
    "!stories/**",
    "!test/**"
  ],
  "sideEffects": [
    "*.css"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/adobe/react-spectrum"
  },
  "dependencies": {
    "@internationalized/date": "^3.12.1",
    "@react-types/shared": "^3.34.0",
    "@spectrum-icons/ui": "^3.7.0",
    "@spectrum-icons/workflow": "^4.3.0",
    "@swc/helpers": "^0.5.0",
    "client-only": "^0.0.1",
    "clsx": "^2.0.0",
    "react-aria": "3.48.0",
    "react-aria-components": "1.17.0",
    "react-stately": "3.46.0",
    "react-transition-group": "^4.4.5",
    "use-sync-external-store": "^1.6.0"
  },
  "publishConfig": {
    "access": "public"
  },
  "peerDependencies": {
    "react": "^16.8.0 || ^17.0.0-rc.1 || ^18.0.0 || ^19.0.0-rc.1",
    "react-dom": "^16.8.0 || ^17.0.0-rc.1 || ^18.0.0 || ^19.0.0-rc.1"
  },
  "devDependencies": {
    "@adobe/spectrum-css-temp": "3.0.0-alpha.1",
    "@babel/cli": "^7.12.10",
    "@babel/core": "^7.24.3",
    "@react-spectrum/style-macro-s1": "3.0.0-alpha.6"
  },
  "targets": {
    "main": false,
    "module": false,
    "types": false,
    "exports-module": {
      "source": [
        "exports/**/*.ts"
      ],
      "distDir": "dist",
      "isLibrary": true,
      "outputFormat": "esmodule",
      "includeNodeModules": [
        "@adobe/spectrum-css-temp"
      ]
    },
    "exports-main": {
      "source": [
        "exports/**/*.ts"
      ],
      "distDir": "dist",
      "isLibrary": true,
      "outputFormat": "commonjs",
      "includeNodeModules": [
        "@adobe/spectrum-css-temp"
      ]
    },
    "legacy-module": {
      "source": [
        "exports/**/*.ts"
      ],
      "distDir": "dist",
      "isLibrary": true,
      "outputFormat": "esmodule",
      "includeNodeModules": [
        "@adobe/spectrum-css-temp"
      ],
      "engines": {
        "browsers": [
          "chrome >= 79",
          "firefox >= 85",
          "safari >= 13"
        ]
      }
    }
  }
}
